import { render, staticRenderFns } from "./Type6b.vue?vue&type=template&id=38fe0078&"
import script from "./Type6b.vue?vue&type=script&lang=js&"
export * from "./Type6b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports